var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
import useComponentDefaults from "../hooks/useComponentDefaults";
import React from "react";
export default function withComponentDefaults(Component, namespace) {
  if (!namespace) {
    console.error(`withComponentDefaults requires namespace`);
    return Component;
  }
  const WrappedComponent = props => {
    let extendedProps = useComponentDefaults(namespace, props);
    return /* @__PURE__ */React.createElement(Component, __spreadValues({}, extendedProps));
  };
  let componentName = Component.displayName || Component.name;
  WrappedComponent.displayName = `WithComponentDefaults(${componentName})`;
  return WrappedComponent;
}